import {
	MetadataItemInfoSection,
	MetadataItemInfoSectionImage,
	MetadataItemInfoSectionLegendInfo,
	MetadataItemInfoSectionParagraph,
	MetadataItemInfoSectionTitle,
} from '../components';

const ChangeMaximumExtent = () => (
	<MetadataItemInfoSection>
		<MetadataItemInfoSectionTitle title="Yearly changes of maximum surface water extent" />
		<MetadataItemInfoSectionParagraph text="The product shows gains (green) and losses (rose) of the maximum water extent between two consecutive years, along with unchanged water and no water areas." />
		<MetadataItemInfoSectionParagraph title="Frequency:" text=" Yearly." />
		<MetadataItemInfoSectionLegendInfo
			items={[
				'0: Unchanged not water',
				'1: Gain maximum water',
				'2: Loss maximum water',
				'3: Unchanged maximum water',
				'255: No data',
			]}
		/>
		<MetadataItemInfoSectionParagraph
			title="Image:"
			text=" Rio Magdalena and swamp complex near Magangué, Colombia."
		/>
		<MetadataItemInfoSectionImage
			imgUrl={require('../../../../../../../../../../data/metadata/img/change_maximum_extent.jpg')}
		/>
	</MetadataItemInfoSection>
);

export default ChangeMaximumExtent;
